import { render, staticRenderFns } from "./RListInput.vue?vue&type=template&id=227b096e&scoped=true&"
import script from "./RListInput.vue?vue&type=script&lang=js&"
export * from "./RListInput.vue?vue&type=script&lang=js&"
import style0 from "./RListInput.vue?vue&type=style&index=0&id=227b096e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227b096e",
  null
  
)

export default component.exports